import { useRouter } from 'next/router';
import {
  excludedRegexList,
  getCategoryName,
  includedRegexList,
} from '../../../utils/getCategory';
import { handleTrack } from '../../../utils/tracker';
import { Button, ButtonVariants } from '../../Atoms/Button';
import { If } from '../../Atoms/Conditionals';
import { CONTENT_PAGE } from '../../Header/constants';
import { Anchor } from '../../Typography/Anchor';
import { NAV_TYPES } from '../../cms/layout/components/header';
import { useScrollDetection } from '../../cms/utils/commonUtils';
import { setCMSPageQueryParams } from '../utils';
import { DIYLink } from './constant';

interface StickyCTAProps {
  buttonText: string;
  buttonStyle?: ButtonVariants;
  link?: string;
  type?: NAV_TYPES;
  showModal?: boolean;
  style?: { outerDivClassess: string };
  alwaysVisible?: boolean;
  label?: string;
}

export const StickyCTA = ({
  buttonText,
  buttonStyle = ButtonVariants['bluebordered'],
  link = DIYLink,
  type = NAV_TYPES.B2B,
  showModal = false,
  style = { outerDivClassess: '' },
  alwaysVisible = false,
  label = '',
}: StickyCTAProps): JSX.Element => {
  const router = useRouter();
  // const [isMounted, setIsMounted] = useState(false);

  // // Fix hydration issue: only enable client-side features after mount
  // useEffect(() => {
  //   setIsMounted(true);
  // }, []);

  const pathName = router && (router.query?.static || router.pathname);

  // Use consistent pathname for SSR and client
  const pathname = router.pathname;

  const pageName =
    getCategoryName({
      regexList: [...includedRegexList, ...excludedRegexList],
      url: pathname,
      parent: true,
    }) || CONTENT_PAGE;

  const refValue = `${pageName}_pages_sticky_bottom`;

  const btnLink =
    type === NAV_TYPES.B2B
      ? setCMSPageQueryParams(refValue, pathName, link, type)
      : link;

  // Only detect scroll after component is mounted (client-side only)
  const hasScrolled = useScrollDetection(100);
  // const shouldShow = isMounted && (alwaysVisible || hasScrolled);

  return (
    <div
      style={{
        boxShadow: '0px -4px 10px 0px rgba(0, 0, 0, 0.12)',
      }}
      className={
        `fixed left-0 bottom-0 bg-white w-full pt-2.5 pb-5 shadow-2xl px-5 z-150 ${
          alwaysVisible || hasScrolled
            ? 'inline-block lg:hidden md:hidden xl:hidden'
            : 'hidden'
        } ` + style.outerDivClassess
      }
      data-testid="StickyCta"
      onClick={(e) => {
        handleTrack({
          label: label || 'stickyCta',
          obj: e.target,
          action: `Click_${buttonText}`,
        });
      }}
    >
      <If condition={showModal}>
        <Button
          className="text-base w-full bg-blue sm:mt-0 sm:mr-1"
          type="button"
          rounded="md"
          variant={buttonStyle}
        >
          {buttonText}
        </Button>
      </If>
      <If condition={!showModal}>
        <Anchor link={decodeURIComponent(btnLink)}>
          <Button
            className="text-base w-full bg-blue sm:mt-0 sm:mr-1"
            type="button"
            rounded="md"
            variant={buttonStyle}
          >
            {buttonText}
          </Button>
        </Anchor>
      </If>
    </div>
  );
};
